import { createFileRoute, Navigate } from '@tanstack/react-router'
import { DateTime } from 'luxon'
import { z } from 'zod'

export const SELECTED_MONTH_FORMAT = 'MM-yyyy'

export const UsageOptions = z.object({
  selectedMonth: z
    .string()
    .regex(/^\d{2}-\d{4}$/, 'Invalid MM-YYYY format')
    .catch(() => DateTime.now().toFormat(SELECTED_MONTH_FORMAT)),
  botId: z
    .string()
    .min(1)
    .optional()
    .catch(() => undefined),
})

export const Route = createFileRoute('/workspaces/$workspaceId/usage/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Navigate
      from={Route.id}
      to="/workspaces/$workspaceId/usage/monthly-summary"
      search={{ selectedMonth: DateTime.now().toFormat(SELECTED_MONTH_FORMAT) }}
      replace
    />
  )
}
